import { render, staticRenderFns } from "./articleCreate.vue?vue&type=template&id=a5b930d4&"
import script from "./articleCreate.vue?vue&type=script&lang=js&"
export * from "./articleCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports